import { Link } from "react-router-dom";
import Button from "./Button";
import { motion, useScroll } from "framer-motion"
import { useEffect, useState } from "react";
import { useMatomo } from "@jonkoops/matomo-tracker-react";

function Header() {
    const { trackEvent } = useMatomo();

    const links = [
        { href: '/', label: 'Home' },
        { href: '/#features', label: 'Features' },
        { href: '/#partners', label: 'Partners' },
        { href: '/#faq', label: 'FAQ' },
        { href: '/#story', label: 'Our story' }
    ];

    const { scrollY } = useScroll();
    const [ fixedHeader, setFixedHeader] = useState(false);
    const [ mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        scrollY.onChange((latest) => {
            setFixedHeader(latest > 0);
        })

        if(mobileMenuOpen && !fixedHeader) {
            setFixedHeader(true);
        }

        if(fixedHeader && !mobileMenuOpen && scrollY.get() === 0) {
            setFixedHeader(false);
        }
    }, [scrollY, mobileMenuOpen, fixedHeader]);

    useEffect(() => {
        if(mobileMenuOpen && !fixedHeader && scrollY.get() > 0) {
            setFixedHeader(true);
        }
    }, [mobileMenuOpen, fixedHeader, scrollY]);

    const handleResize = () => {
        if(window.innerWidth > 768) {
            setMobileMenuOpen(false);
        }
    }
    window.addEventListener('resize', handleResize)

    const headerBackgroundAnimation = {
        transparent: {
            backgroundColor: "#ffffff00",
        },
        white: {
          backgroundColor: "#ffffff"
        }
      }

    const onLinkClicked = (href: string) => {
        mobileMenuOpen && setMobileMenuOpen(false);
        const position = document.getElementById(href.replace('/#', ''))?.offsetTop;
        if(position) {
            window.scrollTo({ top: position, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    const onButtonClick = (type: 'paper' | 'book-call') => {
        trackEvent({ category: 'header', action: `${type} button clicked` });
    }

    return (
        <motion.header className={"pb-6 sticky top-0 left-0 right-0 z-50 h-[90px] " + (fixedHeader ? "shadow-sm" : "") + (mobileMenuOpen ? " h-full " : "")}
            variants={headerBackgroundAnimation} 
            initial="transparent"
            animate={(fixedHeader || mobileMenuOpen) ? "white" : "transparent"}
        >
            <nav className="max-w-screen-xl mx-auto flex flex-row flex-wrap w-screen justify-between pt-[5px]">
                <ul className="flex-1 pl-4 max-[200px]:hidden">
                    <Link to="/" onClick={() => onLinkClicked("/")}>
                    {
                        fixedHeader ? (
                            <img src="logo.svg" alt="logo"/>
                        ) : (
                            <img src="logo-white.svg" alt="logo"/>
                        )
                    }
                    </Link>
                </ul>
                <ul className="flex flex-row flex-wrap justify-center flex-3 max-md:hidden">
                    {links.map((link) => (
                        <li key={link.href} className={`p-2 text-${fixedHeader ? 'slate-900' : 'white'}`} onClick={() => onLinkClicked(link.href)}>
                            <Link to={link.href}>
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
                <ul className="flex-1 max-md:hidden text-right">
                    <Button text="Lite paper" color={fixedHeader ? 'secondary' : 'outline'} size="medium" className="mr-1 mt-1 max-[886px]:px-1.5 max-[886px]:mr-0.5" onClick={() => onButtonClick('paper')}/>
                    <Button text="Book a call" color="primary" size="medium" className="ml-1 mt-1 max-[886px]:px-1" onClick={() => onButtonClick('book-call')}/>
                </ul>
                <ul className="flex-2 md:hidden">
                    <Button text="Menu" icon={mobileMenuOpen ? "long-arrow-right-up" : "menu"} color={fixedHeader ? 'secondary' : 'outline'} size="large" onClick={mobileMenuOpen === true ? () => setMobileMenuOpen(false) : () => setMobileMenuOpen(true)}/>
                </ul>
            </nav>

            {/* Mobile menu */}
            { mobileMenuOpen && 
                    <div className={"bg-white h-auto !md-hidden " + mobileMenuOpen ? "block" : "hidden" }>
                        <ul>
                        {links.map((link) => (
                                <li key={link.href} className={`p-2 text-${fixedHeader ? 'slate-900' : 'white'}`} onClick={() => onLinkClicked(link.href)}>
                                    <Link to={link.href}>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <ul className="text-right">
                            <Button text="Lite paper" color={fixedHeader ? 'secondary' : 'outline'} size="medium" className="mt-2 block mx-auto w-4/12 min-w-[200px]" onClick={() => onButtonClick('paper')}/>
                            <Button text="Book a call" color="primary" size="medium" className="mt-2 block mx-auto w-4/12 min-w-[200px]" onClick={() => onButtonClick('book-call')}/>
                        </ul>
                    </div>
                }
        </motion.header>
    );
}

export default Header;